<template>
  <el-dialog
    v-model="visible"
    title="绑定设备"
    width="450px"
    :close-on-click-modal="false"
    destroy-on-close
  >
    <el-form
      ref="formRef"
      :model="formData"
      :rules="rules"
      label-width="100px"
      v-loading="loading"
    >
      <!-- 当前设备信息 -->
      <el-alert
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 20px"
      >
        <template #title>
          <span>设备：{{ device?.deviceName }} ({{ device?.deviceId }})</span>
        </template>
      </el-alert>

      <!-- 选择检测员 -->
      <el-form-item label="检测员ID" prop="inspectorId">
        <el-input
          v-model.number="formData.inspectorId"
          placeholder="请输入检测员ID"
          clearable
          style="width: 100%"
        />
      </el-form-item>

      <!-- 绑定说明 -->
      <el-alert
        type="success"
        :closable="false"
        show-icon
        style="margin-top: 10px"
      >
        <template #title>
          <span>绑定后，该检测员将可以操作此设备并查看历史数据</span>
        </template>
      </el-alert>
    </el-form>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit"
        >
          确认绑定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { ref, reactive, computed, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { bindDevice } from '@/api/device'

export default {
  name: 'BindDeviceDialog',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    device: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:visible', 'success'],
  setup(props, { emit }) {
    const formRef = ref(null)
    const submitLoading = ref(false)

    const formData = reactive({
      deviceId: '',
      inspectorId: null
    })

    const rules = {
      inspectorId: [
        { required: true, message: '请输入检测员ID', trigger: 'blur' }
      ]
    }

    // 同步 visible
    const visible = computed({
      get: () => props.visible,
      set: (val) => emit('update:visible', val)
    })

    // 监听 visible 变化
    watch(() => props.visible, (val) => {
      if (val) {
        // 重置表单
        formData.deviceId = props.device?.deviceId || ''
        formData.inspectorId = null
      }
    })

    // 提交表单
    const handleSubmit = async () => {
      try {
        await formRef.value.validate()

        submitLoading.value = true

        const response = await bindDevice({
          deviceId: formData.deviceId,
          inspectorId: formData.inspectorId
        })

        if (response.code === 200) {
          ElMessage.success('绑定成功')
          emit('success')
          visible.value = false
        } else {
          ElMessage.error(response.message || '绑定失败')
        }
      } catch (error) {
        console.error('绑定失败：', error)
        ElMessage.error('绑定失败')
      } finally {
        submitLoading.value = false
      }
    }

    return {
      formRef,
      visible,
      submitLoading,
      formData,
      rules,
      handleSubmit
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
